module.exports = __webpack_public_path__ + "img/style-category-icon.b515be0a.svg";